<template>
  <div class="container" :style="{ backgroundImage: `url(${backgroundImagePath})` }">
    <header :style="{ backgroundImage: `url(${backgroundImagePath2})` }">
      <nav>
        <div class="nav_left">

        </div>
        <div class="nav_right">
          <div class="item bgcolor" @click="openUrl(download_url)">
            漫迷创作下载
          </div>
          <div class="item bgcolor" v-if="isUserLogin" @click="openUserCenters">
            素材上传
          </div>
          <div class="item bgcolor" @click="qrcodeShow = true">变现渠道</div>
          <div class="item bgcolor" v-if="isUserLogin" @click="openUserCenter">
            用户中心
          </div>
          <div class="item bgcolor" v-if="isUserLogin" @click="tuichu">
            退出登录
          </div>

          <div class="item bgcolor" v-else @click="loginShow = true">登录</div>
          <div class="item bgcolor" @click="moneyShow = true">充值</div>
        </div>
      </nav>
    </header>
    <div class="category-nav-container">
      <div class="category-list">
        <div class="category-item" v-for="(item, index) in fenleiList" :key="item.term_id"
          :class="{ 'active': index === activeIndex }" @click="selectCategory(index, item.term_id)">
          <img class="category-icon" :src="item.icon" :alt="item.name" />
          <span class="category-name">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="searchbox" v-if="activeIndex != -1" style="width: calc(100vw - 3rem);">
      <img :src="themeState.isDark
        ? require('@/assets/index/tu3.png')
        : require('@/assets/bindex/tu3.png')
        " alt="" />
      <input v-model="searchValue1" type="text" placeholder="搜索素材名称/类型" @keydown.enter="searchSucaiList" />
      <button @click="searchSucaiList()">搜索</button>
    </div>
    <div class="sucaiList2" v-if="activeIndex != -1" style=" width: calc(100vw - 3rem);">
      <div class="waterfall_item2" v-for="(item, idx) in sucaiList.data.data" :key="idx" @click="tuDetail(item)">
        <!-- <el-image :src="item.image_cover" lazy alt="Image" style="border-radius: 15px;"/> -->
        <!-- 关键图片（如首屏 Hero Image）应优先加载，避免懒加载影响 LCP（最大内容绘制）使用 fetchpriority="high"（现代浏览器支持）提升关键图片加载优先级。 -->
        <el-image :src="item.image_cover" :fetchpriority="isHeroImage ? 'high' : 'auto'" :lazy="!isHeroImage"
          :alt="item.post_title" :loading="isHeroImage ? 'eager' : 'lazy'" style="border-radius: 15px;"
          class="material-image" />
        <el-text type="success" style="color: white; text-align: center; display: block;font-size: 14px;"
          v-if="item.is_model == 1">
          {{ item.post_title }}
        </el-text>
        <el-text type="success" style="color: yellow; text-align: center; display: block;font-size: 14px;"
          v-if="item.is_model == 2">
          {{ item.post_title }}
        </el-text>
      </div>
    </div>
    <!-- 分页 -->
    <div class="fenye" v-if="activeIndex != -1">
      <el-pagination background layout="prev, pager, next" :page-size="15" :current-page="sucaiList.data.current_page"
        :page-count="sucaiList.data.last_page" :total="sucaiList.data.total"
        @current-change="getSucaiList(dqId, $event)" />
    </div>
    <el-carousel trigger="click" v-if="activeIndex == -1">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <el-image style="width: 100%; height: 100%; object-fit: cover" :src="item.url" loading="lazy" alt="" />
      </el-carousel-item>
    </el-carousel>

    <footer>
      <div class="ceo_grid">
        <div class="ceo_grid1">
          <a href="" target="_blank" class="foot-logo ceo-display-block"><img
              src="http://image.manmcz.com/wp-content/uploads/2024/11/2024110608271095.png" /></a>
          <p>本站提供高质量简笔画多人物素材推荐有价值的好东西资源分享。</p>
        </div>
      </div>

      <div class="foot_cop">
        <div class="ceo-float-left">
          <span>该版权为山西壹拾贰网络科技有限公司版权所有</span>
          <a href="http://www.beian.gov.cn/" target="_blank" rel="noreferrer nofollow"><img
              src="https://jianbihua.manmcz.com/wp-content/themes/ceomax/static/images/ceo-110.png" height="6" /></a>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer nofollow">晋ICP备2024033569号-2</a>
        </div>
        <div class="ceo-float-right ceo-visible@s">
          <span>Theme By
            <a href="https://www.ceotheme.com/" target="_blank" rel="noreferrer nofollow">CeoTheme</a></span>
        </div>
      </div>
    </footer>

    <div class="mengban" v-if="loginShow">
      <div class="loginbox" v-if="isLogin">
        <div class="loginbox_left">
          <div class="login_title">
            <h3>登录</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input v-model="username" class="input_box" placeholder="请输入用户名/邮箱">
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input v-model="password" class="input_box" placeholder="请输入密码" type="password">
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>

          <div class="login_btn bgcolor" @click="login_btn()">立即登录</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>
          <div class="bottom_box">
            <div class="box_left" @click="isLogin = false">
              没有账号？立即注册
            </div>
            <div class="box_right"></div>
          </div>
        </div>
        <div class="loginbox_right"></div>
        <img class="cha" @click="loginShow = false" src="../../src/assets/index/cha.png" alt="" />
      </div>
      <div class="loginbox registerbox" v-else>
        <div class="loginbox_left">
          <div class="login_title">
            <h3>注册</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input v-model="email" class="input_box" placeholder="请输入邮箱">
            <template #prefix>
              <img src="../../src/assets/login/email.png" alt="" />
            </template>
          </el-input>
          <el-input v-model="username" class="input_box" placeholder="请输入用户名">
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input v-model="password" class="input_box" placeholder="请输入您的密码" type="password">
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>
          <el-input v-model="confirm_password" class="input_box" placeholder="请再次输入密码" type="password">
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>
          <div class="xieyi">
            <input v-model="isAgree" id="agreement" name="agreen" type="checkbox" class="agreen_btn" required="" />
            我已阅读并同意 <a href="#">《注册协议》</a>
          </div>
          <div class="login_btn bgcolor" @click="register_btn()">立即注册</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>

          <div class="bottom_box">
            <div class="box_left" @click="isLogin = true">
              已有账号？立即登录
            </div>
          </div>
        </div>
        <div class="loginbox_right"></div>
        <img class="cha" @click="loginShow = false" src="../../src/assets/index/cha.png" alt="" />
      </div>
    </div>
    <!-- 公告弹框 -->

    <div v-if="showAnnouncement" class="announcement-modal">
      <div class="modal-overlay" @click="closeModal"></div>
      <div class="modal-container">
        <div class="modal-content">
          <div class="modal-header">
            <h3>网站公告</h3>
            <button class="close-btn" @click="closeModal">×</button>
          </div>

          <div class="scrollable-content">
            <img :src="gonggao_img" alt="公告图片" class="announcement-image" @click="handleImageClick">
          </div>

          <div class="modal-footer">
            <label class="dont-show-again">
              <input type="checkbox" v-model="dontShowAgain" />
              <span>不再显示此公告</span>
            </label>
            <button class="confirm-btn" @click="closeModal">我知道了</button>
          </div>
        </div>
      </div>
    </div>



    <div class="mengban" v-if="userShows">
      <div class="userinfobox">
        <img class="guanbi" @click="userShows = false" src="../../src/assets/chacha.png" alt="" />
        <div class="userinfo">
          <div class="userinfo_left">
            <div>
              <div class="userinfo_name">定制类人物</div>
              <div class="tishi1">
                建议大小: 15M以内为最佳模式，支持:
                psd格式的源文件，图片大小请不要超过20M
              </div>
            </div>
          </div>
        </div>
        <div class="infobox">
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">会员ID</div>
              <el-input v-model="userinfo.id" disabled placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">素材类别</div>
              <el-input placeholder="" value="定制专属人物" disabled>
              </el-input>
            </div>
          </div>
        </div>
        <div class="infobox_item">
          <div class="input_box">
            <div class="input_name">素材封面</div>
            <el-upload action="https://api.manmcz.com/index.php/api/home/uploadfile?type=1"
              :on-success="handleSuccess1">
              <el-button type="primary">上传素材封面</el-button>
            </el-upload>
          </div>
          <div class="input_box">
            <div class="input_name">素材文件</div>
            <el-upload action="https://api.manmcz.com/index.php/api/home/uploadfile?type=2" :on-success="handleSuccess">
              <el-button type="primary">上传素材psd文件</el-button>
            </el-upload>
          </div>
        </div>
        <div class="infobox">
          <div class="baocun bgcolor" @click="insertuploadPsd()">保存设置</div>
        </div>
      </div>
    </div>
    <div class="mengban" v-if="userShow">
      <div class="userinfobox">
        <img class="guanbi" @click="userShow = false" src="../../src/assets/chacha.png" alt="" />

        <div class="infobox">
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">会员ID</div>
              <el-input v-model="userinfo.id" disabled placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">注册时间</div>
              <el-input v-model="userinfo.user_registered" disabled placeholder="">
              </el-input>
            </div>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">昵称</div>
              <el-input v-model="userinfo.display_name" placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">邮箱账号</div>
              <el-input v-model="userinfo.user_email" disabled placeholder="">
              </el-input>
            </div>
          </div>
          <div class="infobox_item" v-if="userinfo.id == 57">
            <div class="input_box">
              <div class="input_name">用户邮箱</div>
              <el-input v-model="userinfo.save_user_id" placeholder="">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">设置密码</div>
              <el-input v-model="userinfo.save_password" placeholder="">
              </el-input>
            </div>
          </div>
          <div class="tishi2">
            凡使用星空素材网学员必须在漫迷文创机构使用,否则将进行责任追寻
            <span>另抖音昵称及账号在抖音平台不允许修改</span>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">抖音授权账号①</div>
              <el-input :disabled="douyin_name1 != ''" v-model="userinfo.douyin_name1"
                placeholder="请完善您的抖音账号①（格式为抖音名称+抖音ID）...">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">抖音授权账号②</div>
              <el-input :disabled="douyin_name2 != ''" v-model="userinfo.douyin_name2"
                placeholder="请完善您的抖音账号②（格式为抖音名称+抖音ID）...">
              </el-input>
            </div>
          </div>
          <div class="infobox_item">
            <div class="input_box">
              <div class="input_name">抖音授权账号③</div>
              <el-input :disabled="douyin_name3 != ''" v-model="userinfo.douyin_name3"
                placeholder="请完善您的抖音账号③（格式为抖音名称+抖音ID）...">
              </el-input>
            </div>
            <div class="input_box">
              <div class="input_name">手机号码</div>
              <el-input v-model="userinfo.phone" placeholder="请输入您的手机号码...">
              </el-input>
            </div>
          </div>
          <div class="baocun bgcolor" @click="baocunUserinfo()">保存设置</div>
        </div>
      </div>
    </div>
    <div class="mengban" v-if="qrcodeShow">
      <div class="qrcodebox">
        <img :src="qrcode_url" alt="" />
        <img class="cha" @click="qrcodeShow = false" src="../../src/assets/index/cha.png" alt="" />
      </div>
    </div>

    <div class="mengban" v-if="moneyShow">
      <div class="qrcodebox">
        <img src="http://jianbihua.manmcz.com/wp-content/uploads/2025/06/service_2.png" alt="" />
        <img class="cha" @click="moneyShow = false" src="../../src/assets/index/cha.png" alt="" />
      </div>
    </div>
    <!-- 滚动到顶部的图标 -->
    <div class="scroll-to-top" v-if="showScrollToTop" @click="scrollToTop">
      <img src="../assets/up.png" alt="Scroll to Top" />
    </div>

    <!-- 显示二维码的图标 -->
    <div class="qrcode-icon" @mouseenter="showQrcode = true" @mouseleave="showQrcode = false">
      <img src="../assets/wx.png" alt="QR Code" />
      <div class="qrcode-popup" v-if="showQrcode">
        <img :src="qrcode_url2" alt="QR Code" />
      </div>
    </div>

    <!-- 更新公告弹窗 -->
    <el-dialog v-model="dialogTableVisible" :show-close="false" top="5vh" style="height: 62rem;" width="1000"
      class="update-dialog" :before-enter="beforeEnter" :before-leave="beforeLeave">
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <h4 :id="titleId" :class="titleClass">
          </h4>
          <el-button type="text" @click="close" class="close-btn">
            <el-icon>
              <CircleCloseFilled />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="dialog-content">
        <!-- 标题区域 -->
        <div class="announcement-title">
          <h2>漫迷文创简笔画软件闪耀登场！</h2>
          <p class="subtitle">更智能，更自由，点亮你的创作灵感！</p>
        </div>
        <!-- 欢迎致辞 -->
        <div class="welcome-message">
          <p>亲爱的漫迷们：</p>
          <p>大家好！感谢大家一直以来的支持与陪伴。为了给大家带来更极致、更畅快的剪辑体验，我们满怀激动地宣布，「漫迷文创简笔画」迎来了重磅更新！</p>
          <p>本次更新，我们倾听了无数用户的宝贵建议，专注于 <span class="highlight">"智能辅助"</span> 与 <span class="highlight">"创意自由"</span>
            两大核心，带来了一系列让你心动的新功能与优化！</p>
        </div>
        <div>
          <div class="block text-center">
            <el-carousel style="height:35rem;width: 100%;">
              <el-carousel-item style="width: 100%;height: 100%;">
                <!-- 添加了object-fit: contain确保图片完整显示，保持比例 -->
                <img src="../assets/index/sucai2.png" style="width: 100%;height: 100%;object-fit: contain;"
                  alt="软件功能展示图1">
              </el-carousel-item>
              <el-carousel-item style="width: 100%;height: 100%;">
                <img src="../assets/index/sucai3.png" style="width: 100%;height: 100%;object-fit: contain;"
                  alt="软件功能展示图2">
              </el-carousel-item>
              <el-carousel-item style="width: 100%;height: 100%;">
                <img src="../assets/index/sucai4.png" style="width: 100%;height: 100%;object-fit: contain;"
                  alt="软件功能展示图3">
              </el-carousel-item>
              <el-carousel-item style="width: 100%;height: 100%;">
                <img src="../assets/index/sucai5.png" style="width: 100%;height: 100%;object-fit: contain;"
                  alt="软件功能展示图4">
              </el-carousel-item>
              <el-carousel-item style="width: 100%;height: 100%;">
                <img src="../assets/index/sucai6.png" style="width: 100%;height: 100%;object-fit: contain;"
                  alt="软件功能展示图5">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 新功能列表 -->
        <div class="features-container">
          <!-- 功能1 -->
          <div class="feature-card">
            <div class="feature-icon">🤖</div>
            <div class="feature-content">
              <h3 class="feature-title">AI智能推理辅助</h3>
              <p class="feature-description">AI将自动为你提取出清晰、干净的素材、场景、道具，智能推理角色动作与场景构图，快速生成多样化画面</p>
              <p class="feature-benefit">新手也能秒变大神！</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🎬</div>
            <div class="feature-content">
              <h3 class="feature-title">剪映拖拽增强插件</h3>
              <p class="feature-description">海量精品场景模板，覆盖全品类创作需求，预置多风格角色模型，支持自定义调整，勾选心仪动作，直接拖入剪映时间轴即刻生效
              </p>
            </div>
          </div>
          <!-- 功能2 -->
          <div class="feature-card">
            <div class="feature-icon">🍌</div>
            <div class="feature-content">
              <h3 class="feature-title">纳米香蕉一键生图</h3>
              <p class="feature-description">无需复杂参数，你想什么，就写什么。无论是"一只穿着宇航服的柯基在月球上吃火锅"还是"赛博朋克风格的江南水乡"，输入描述，点击生成，魔法即刻发生。
              </p>
            </div>
          </div>
          <!-- 功能3 -->
          <div class="feature-card">
            <div class="feature-icon">🧩</div>
            <div class="feature-content">
              <h3 class="feature-title">图层系统优化</h3>
              <p class="feature-description">图层操作更直观！新增图层分组、多种混合模式和一键蒙版功能。</p>
              <p class="feature-benefit">管理复杂作品时更加得心应手，轻松实现高级绘画效果，专业感up！up！</p>
            </div>
          </div>
          <!-- 功能4 -->
          <div class="feature-card">
            <div class="feature-icon">⚡</div>
            <div class="feature-content">
              <h3 class="feature-title">性能全面提升</h3>
              <p class="feature-description">优化了应用启动速度和笔迹延迟，大幅降低了闪退概率。</p>
              <p class="feature-benefit">享受如丝般顺滑的创作过程，灵感迸发时不再被卡顿打断。</p>
            </div>
          </div>
        </div>
        <!-- 结尾部分 -->
        <div class="closing-message">
          <p>我们始终相信，每一个人都是天生的创作者。漫迷文创愿成为你手中最得心应手的画笔，陪伴你记录每一个闪光的灵感瞬间。</p>
          <p>如果你喜欢这次更新，别忘了在应用商店给我们一个五星好评，这是对我们最大的鼓励！</p>
          <p class="gratitude">创作路上，感恩有你。</p>
          <p class="signature">漫迷文创团队 敬上</p>
        </div>
      </div>
      <div class="dialog-footers">
        <el-button type="primary" @click="handleViewMore" class="primary-btn">
          立即更新体验
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import {
  register,
  login,
  getsortData,
  getData,
  getUserinfo,
  saveUserinfo,
  insertuploadpsds,
  index,
  logut,
  peizhi,
} from "@/api/api.js";
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { useTheme } from "@/theme";
import request from "@/utils/request"; // 引入 axios 实例
import { CircleCloseFilled } from '@element-plus/icons-vue';
import { ElMessage } from "element-plus";
const { themeState, toggleTheme } = useTheme(); // 获取全局状态和方法
const backgroundImagePath = ref("/assets/index/indexbg.jpg");
const backgroundImagePath2 = ref("/assets/index/indexbg2.jpg");

const loginShow = ref(false);
const userShow = ref(false);
const userShows = ref(false);
const isLogin = ref(true);
const qrcodeShow = ref(false);
const moneyShow = ref(false);

const showAnnouncement = ref(false);
const notShowAgain = ref(false);
const dialogTableVisible = ref(false)
const handleImageClick = () => {
  window.open(gonggao_img.value, '_blank');
}

const closeModal = () => {
  if (notShowAgain.value) {
    // 如果用户选择了不再显示，存储到localStorage
    localStorage.setItem('hideAnnouncement', 'true')
  }
  showAnnouncement.value = false;
}
const animationTriggered = ref(false);

const bannerList = ref([]);

const avatar_url = ref("");
const avatar_url2 = ref("");

const fenleiList = ref([
  {
    icon: "https://image.manmcz.com/wp-content/uploads/2024/12/202412230928593.png",
    name: "都市人物",
  },
  {
    icon: "http://image,manmcz.com/wp-content/uploads/2024/11/2024110709535254.png",
    name: "历史人物",
  },
]);
const searchValue1 = ref("");
const searchValue2 = ref("");
const sucaiList = reactive({
  data: [],
});
const dqId = ref(localStorage.getItem("dqId") || "");
// const activeIndex = ref(-1);
const activeIndex = ref(localStorage.getItem("activeIndex") || -1);
const activeId = ref(localStorage.getItem("activeId") || "");
const username = ref("");
const gonggao_img = ref("");
const password = ref("");
const confirm_password = ref("");
const email = ref("");
const isAgree = ref(false);
const isUserLogin = ref(localStorage.getItem("token"));
const login_btn = () => {
  if (username.value && password.value) {
    const formData = new FormData();
    formData.append("username", username.value);
    formData.append("password", password.value);

    login(formData).then((res) => {
      console.log(res);
      if (res.code === 100) {
        localStorage.setItem("token", res.data.token);
        ElMessage.success("登录成功");
        isUserLogin.value = res.data.token;
        loginShow.value = false;
        // isLogin.value = false;
      }
    });
  } else {
    ElMessage.error("用户名或密码不能为空");
  }
};
const register_btn = () => {
  if (!isAgree.value) {
    ElMessage.error("请先同意协议");
    return;
  }
  if (
    email.value &&
    username.value &&
    password.value &&
    confirm_password.value
  ) {
    if (password.value === confirm_password.value) {
      const formData = new FormData();
      formData.append("username", username.value);
      formData.append("password", password.value);
      formData.append("email", email.value);
      formData.append("confirm_password", confirm_password.value);
      register(formData).then((res) => {
        console.log(res);
        if (res.code === 100) {
          ElMessage.success("注册成功");
          // loginShow.value = true;
          // isLogin.value = false;
        }
      });
    } else {
      ElMessage.error("两次密码输入不一致");
    }
  } else {
    ElMessage.error("邮箱、用户名、密码不能为空");
  }
};
const userinfo = reactive({
  id: "",
  user_registered: "",
  display_name: "",
  user_email: "",
  phone: "",
  douyin_name1: "",
  douyin_name2: "",
  douyin_name3: "",
  save_user_id: "",
  save_pssword: ""
});
const douyin_name1 = ref("");
const douyin_name2 = ref("");
const douyin_name3 = ref("");
const openUserCenter = () => {
  getUserinfo(isUserLogin.value).then((res) => {
    console.log(res);
    if (res.code === 100) {
      userinfo.id = res.data.ID;
      userinfo.user_registered = res.data.user_registered;
      userinfo.display_name = res.data.display_name;
      userinfo.user_email = res.data.user_email;
      userinfo.phone = res.data.phone;
      userinfo.douyin_name1 = res.data.douyin_name1;
      douyin_name1.value = res.data.douyin_name1;
      userinfo.douyin_name2 = res.data.douyin_name2;
      douyin_name2.value = res.data.douyin_name2;
      userinfo.douyin_name3 = res.data.douyin_name3;
      douyin_name3.value = res.data.douyin_name3;
      userShow.value = true;
    }
  });
};
const handleViewMore = () => {
  // 1. 定义目标跳转链接（你的飞书文档链接）
  const targetUrl = "https://wcnn04eeapjz.feishu.cn/wiki/IHtDwhCxPisPnikcsTQcurc5nuf?from=from_copylink";

  // 2. 打开外部链接（_blank 表示新窗口打开，避免离开当前页面）
  window.open(targetUrl, "_blank");

  // 3. 关闭弹窗（提升用户体验，可选但推荐）
  dialogTableVisible.value = false;
};
// 动画钩子
const beforeEnter = (el) => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
};

const beforeLeave = (el) => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
};

// 功能卡片动画
const featureAnimation = (index) => {
  return animationTriggered.value ? `feature-enter-${index}` : '';
};
const handleSuccess = (response) => {
  // 根据实际API结构调整此处
  avatar_url.value = response.data;
  console.log(response.data)
};

const handleSuccess1 = (response) => {
  // 根据实际API结构调整此处
  avatar_url2.value = response.data;
};

const openUserCenters = () => {
  getUserinfo(isUserLogin.value).then((res) => {
    console.log(res);
    if (res.code === 100) {
      userinfo.id = res.data.ID;
      userinfo.user_registered = res.data.user_registered;
      userinfo.display_name = res.data.display_name;
      userinfo.user_email = res.data.user_email;
      userinfo.phone = res.data.phone;
      userinfo.douyin_name1 = res.data.douyin_name1;
      douyin_name1.value = res.data.douyin_name1;
      userinfo.douyin_name2 = res.data.douyin_name2;
      douyin_name2.value = res.data.douyin_name2;
      userinfo.douyin_name3 = res.data.douyin_name3;
      douyin_name3.value = res.data.douyin_name3;
    }
  });
  userShows.value = true;
};

const baocunUserinfo = () => {
  const formData = new FormData();
  formData.append("email", userinfo.user_email);
  formData.append("phone", userinfo.phone);
  formData.append("nickname", userinfo.display_name);
  formData.append("douyin_name1", userinfo.douyin_name1);
  formData.append("douyin_name2", userinfo.douyin_name2);
  formData.append("douyin_name3", userinfo.douyin_name3);
  formData.append("save_user_id", userinfo.save_user_id);
  formData.append("save_password", userinfo.save_password);
  formData.append("token", isUserLogin.value);

  saveUserinfo(formData).then((res) => {
    console.log(res);
    if (res.code === 100) {
      ElMessage.success("保存成功");
      userShow.value = false;
    }
  });
};

const insertuploadPsd = () => {
  const formData = new FormData();
  formData.append("avatar_url", avatar_url.value);
  formData.append("guid", avatar_url2.value);
  formData.append("token", isUserLogin.value);
  insertuploadpsds(formData).then((res) => {
    console.log(res);
    if (res.code === 100) {
      ElMessage.success("保存成功");
      userShows.value = false;
    }
  });
};

const setRemUnit = () => {
  const baseSize = 16;
  let scale = document.documentElement.clientWidth / 1920;

  // 判断是否为移动设备，这里假设移动设备的最大宽度为 768px
  if (document.documentElement.clientWidth <= 768) {
    scale = 0.3;
  }

  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};

const openUrl = (url) => {
  console.log(url, '=打印的url');

  if (url) {
    window.open(url, "_blank");
  }
};

onMounted(() => {
  getLiebiao();
  setRemUnit();
  getIndex();
  getPeizhi();
  dialogTableVisible.value = true
  window.addEventListener("resize", setRemUnit);
});
const cunActiveIndex = (index, id) => {
  localStorage.setItem("activeIndex", index);
  localStorage.setItem("dqId", id);
};
const getIndex = () => {
  index().then((res) => {
    console.log(res);
    if (res.code == 100) {
      backgroundImagePath.value = res.data.background_image;
      backgroundImagePath2.value = res.data.canva_image[0].url;
      // backgroundImagePath.value = 'http://jianbihua.manmcz.com/wp-content/uploads/2025/07/背景4.jpg';
      // backgroundImagePath2.value = 'http://jianbihua.manmcz.com/wp-content/uploads/2025/07/banner-1.jpg';
      bannerList.value = res.data.banner_image;
      gonggao_img.value = res.data.gonggao_img;
      const hideAnnouncement = localStorage.getItem('hideAnnouncement')
      if (!hideAnnouncement) {
        // 设置2秒后显示
        setTimeout(() => {
          showAnnouncement.value = res.data.showAnnouncement;
        }, 15000)
      }

    }
  });
};
const qrcode_url = ref("");
const qrcode_url2 = ref("");
const download_url = ref("");
const getPeizhi = () => {
  peizhi().then((res) => {
    console.log(res);
    if (res.code == 100) {
      // download_url.value = res.data.software_download_url;
      download_url.value = 'https://wcnn04eeapjz.feishu.cn/wiki/IHtDwhCxPisPnikcsTQcurc5nuf?from=from_copylink'
      qrcode_url.value = res.data.qrcode_url;
      qrcode_url2.value = res.data.customer_service_image;
      // backgroundImagePath.value = res.data.background_image;
      // backgroundImagePath2.value = res.data.canva_image[0].url;
      // bannerList.value = res.data.banner_image;
    }
  });
};
const getLiebiao = async () => {
  try {
    const response = await getsortData();
    console.log("登录成功:", response);
    console.log(response.data);
    if (response.code === 1) {
      fenleiList.value = response.data;
      // if (localStorage.getItem("activeIndex")) {
      //   getSucaiList(response.data[activeIndex.value].term_id);
      // }
      if (localStorage.getItem("activeIndex")) {
        getSucaiList(response.data[activeIndex.value].term_id);
        activeIndex.value = activeIndex.value;
      } else {
        getSucaiList(response.data[0].term_id);
        activeIndex.value = 0;
      }

      // dqId.value = response.data[0].term_id;
    }
  } catch (error) {
    console.error("登录失败:", error);
  }
};

const getSucaiList = (id, page = 1, name = "") => {
  console.log(id, id);
  getData({
    sort_id: id ? id : dqId.value,
    limit: 15,
    page: page,
    name: searchValue2.value,
    token: isUserLogin.value
  }).then((res) => {
    // console.log(res.data);
    sucaiList.data = res.data;
  });
};
// 搜索素材
const searchSucaiList = (id, page = 1) => {
  searchValue2.value = searchValue1.value;
  getData({
    sort_id: id ? id : dqId.value,
    limit: 15,
    page: page,
    name: searchValue1.value,
  }).then((res) => {
    sucaiList.data = res.data;
  });
};
import { useRouter } from "vue-router";
const router = useRouter();
const tuDetail = (item) => {
  router.push({
    path: "/sucaiDetail",
    query: {
      id: item.id,
      image_cover: item.post_content,
      post_title: item.post_title,
      is_model: item.is_model
    },
  });
};
const tuichu = () => {
  localStorage.removeItem("token");
  isUserLogin.value = "";
};

const showScrollToTop = ref(false);
const showQrcode = ref(false);

const handleScroll = () => {
  if (window.scrollY > 300) {
    showScrollToTop.value = true;
  } else {
    showScrollToTop.value = false;
  }
};

const selectCategory = (index, termId) => {
  activeIndex.value = index;
  searchValue1.value = '';
  searchValue2.value = '';
  getSucaiList(termId);
  dqId.value = termId;
  cunActiveIndex(index, termId);

  // 平滑滚动到选中项
  const container = document.querySelector('.category-nav-container');
  const item = document.querySelectorAll('.category-item')[index];
  if (item) {
    const itemLeft = item.offsetLeft;
    const itemWidth = item.offsetWidth;
    const containerWidth = container.offsetWidth;

    container.scrollTo({
      left: itemLeft - (containerWidth - itemWidth) / 2,
      behavior: 'smooth'
    });
  }
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", setRemUnit);
});
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 26.25rem;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

nav {
  width: calc(100vw - 3rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 6.25rem;

  .nav_left {
    font-size: 1.2rem;
  }

  .nav_right {
    display: flex;
    align-items: center;
  }

  .item {
    cursor: pointer;
    font-size: 1.2rem;
    margin-left: 0.625rem;
    /* 0.625rem -> 0.625rem */
    padding: 0.25rem 0.9375rem;
    /* 4px 15px -> 0.25rem 0.9375rem */
    border-radius: 0.25rem;
    /* 4px -> 0.25rem */
  }
}

/* 修改整个页面的滚动条宽度 */
::-webkit-scrollbar {
  width: 0.625rem;
  /* 水平滚动条的宽度 */
  height: 0.625rem;
  /* 垂直滚动条的高度 */
}

/* 修改特定元素的滚动条宽度 */
.some-element::-webkit-scrollbar {
  width: 0.625rem;
  height: 0.625rem;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background: var(--background-color1);
  font-size: 1rem;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.fenlei_list {
  width: calc(100vw - -41rem);
  margin: 1.5rem 0;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  .list_item {
    display: flex;
    align-items: center;
    padding: 0.5125rem;
    background: #fff;
    border-radius: 0.25rem;
    height: 2.5rem;
    cursor: pointer;
    flex-shrink: 0;

    img {
      width: 1.875rem;
      height: 1.875rem;
      border-radius: 20%;
    }

    .list_item_text {
      margin: 0 0.3125rem;
      font-size: 1rem;
    }
  }

  @media (min-width: 1200px) {
    flex-wrap: wrap;
    width: calc(1200px - 3rem);

    .list_item {

      /* padding: 1rem; */
      .list_item_text {
        margin: 0 0.3125rem;
        font-size: 1.4rem;
      }
    }
  }

  .active {
    background: #3c5aff;
    color: #fff;
  }
}

.searchbox {
  margin: 1.5rem;
  width: calc(100vw - -41rem);

  @media (min-width: 1200px) {
    width: calc(1200px - 3rem);
  }

  height: 3.5rem;
  padding: 0 1.5rem;
  box-sizing: border-box;
  background: var(--background-color3);
  display: flex;
  align-items: center;
  border-radius: 0.5rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;
  }

  input {
    border: none;
    /* 移除边框 */
    outline: none;
    /* 移除聚焦时的轮廓 */
    background: transparent;
    /* 设置背景为透明 */
    padding: 0;
    /* 移除内边距 */
    margin: 0;
    /* 移除外边距 */
    width: 100%;
    /* 使输入框宽度占满父容器 */
    height: 100%;
    /* 使输入框高度占满父容器 */
    font-size: 1rem;
    /* 设置字体大小 */
    color: var(--text-color);
    /* 设置字体颜色 */
    box-sizing: border-box;
    /* 确保内边距和边框不会影响宽度和高度 */
  }

  input::placeholder {
    color: var(--placeholder-color);
    /* 设置占位符颜色 */
    opacity: 1;
    /* Firefox */
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: var(--placeholder-color);
  }

  input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: var(--placeholder-color);
  }

  button {
    width: 4rem;
    height: 2rem;
    cursor: pointer;
    font-size: 1rem;
    background: var(--background-color2);
    color: var(--text-color);
  }
}

.sucaiList2 {
  margin-top: 1.5rem;
  width: calc(100vw - -41rem);
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;

  @media (min-width: 1200px) {
    width: calc(1200px - 3rem);
  }

  /* justify-content: space-between; */
  .waterfall_item2 {
    width: calc((100% / 5) - 0.625rem);
    margin-bottom: 0.625rem;

    img {
      width: 100%;
    }

    p {
      text-align: left;
    }
  }
}

.fenye {
  margin-bottom: 1.25rem;
}

.el-carousel {
  width: calc(100vw - 3rem);
  border-radius: 0.5rem;
  height: calc(100vh - 18.75rem);
  margin: 1.5rem 0;
}

.el-carousel__item {
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .el-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

:deep(.el-carousel__container) {
  height: 100% !important;
}

.scroll-to-top {
  position: fixed;
  bottom: 2.5rem;
  /* 40px -> 2.5rem */
  right: 2.5rem;
  /* 40px -> 2.5rem */
  cursor: pointer;
  z-index: 1000;
  padding: 0.3125rem;
  /* 5px -> 0.3125rem */
  background: #fff;
  border-radius: 0.3125rem;

  /* 5px -> 0.3125rem */
  img {
    width: 1.875rem;
    /* 30px -> 1.875rem */
    height: 1.875rem;
    /* 30px -> 1.875rem */
  }
}

.qrcode-icon {
  position: fixed;
  bottom: 6.25rem;
  /* 100px -> 6.25rem */
  right: 2.5rem;
  /* 40px -> 2.5rem */
  cursor: pointer;
  z-index: 1000;
  padding: 0.3125rem;
  /* 5px -> 0.3125rem */
  background: #fff;
  border-radius: 0.3125rem;

  /* 5px -> 0.3125rem */
  img {
    width: 1.875rem;
    /* 30px -> 1.875rem */
    height: 1.875rem;
    /* 30px -> 1.875rem */
  }
}

.qrcode-popup {
  position: absolute;
  bottom: 0rem;
  /* 0px -> 0rem */
  right: 3.125rem;
  /* 50px -> 3.125rem */
  background: #fff;
  border: 0.0625rem solid #ccc;
  /* 1px -> 0.0625rem */
  padding: 0.625rem;
  /* 10px -> 0.625rem */
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);

  /* 2px 10px -> 0.125rem 0.625rem */
  img {
    width: 9.375rem;
    /* 150px -> 9.375rem */
    height: 9.375rem;
    /* 150px -> 9.375rem */
  }
}

.category-nav-container {
  width: 100%;
  padding: 0 1.5rem;
  margin: 1.5rem 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }
}

.category-list {
  display: inline-flex;
  gap: 1.25rem;
  padding-bottom: 0.5rem;
  white-space: nowrap;
}

.category-item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 0.75rem 1rem;
  // background: #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.active {
    background: #3c5aff;
    color: #fff;
    box-shadow: 0 4px 12px rgba(19, 173, 255, 0.3);

    .category-name {
      color: #fff;
    }
  }
}

.category-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 0.5rem;
  object-fit: contain;
}

.category-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  text-align: center;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .category-item {
    min-width: 100px;
    padding: 1rem 1.25rem;
  }

  .category-icon {
    width: 70px;
    height: 70px;
    border-radius: 40px;
  }

  .category-name {
    font-size: 14px;
  }
}
</style>
<style scoped>
/* 蒙层和居中定位 */
.announcement-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

/* 弹窗容器 */
.modal-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  /* 限制最大高度 */
  background: white;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 内容区域 */
.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  /* 启用垂直滚动 */
  min-height: 0;
  /* 关键！允许flex item缩小 */
  padding: 0 20px;
}


.image-wrapper {
  min-height: 100%;
  /* 确保容器足够高 */
  display: flex;
  justify-content: center;
}

.announcement-image {
  max-width: 100%;
  height: auto;
  display: block;
}


/* 头部样式 */
.modal-header {
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

/* 底部样式 */
.modal-footer {
  padding: 12px 20px;
  background: #f8f9fa;
  border-top: 1px solid #eee;
  flex-shrink: 0;
}

.dont-show-again {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.dont-show-again input {
  margin-right: 8px;
}

.confirm-btn {
  padding: 6px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.confirm-btn:hover {
  background: #40a9ff;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.05);
}

/* 滚动条样式 */
.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.update-dialog {
  --el-dialog-border-radius: 16px;
  --el-dialog-padding-primary: 0;
  overflow: hidden;
}

/* 头部样式 */
.my-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
  color: white;
  padding: 16px 24px;
  border-bottom: none;
}

.my-header h4 {
  margin: 0;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  font-size: 20px;
}

.close-btn {
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

/* 内容区域 */
.dialog-content {
  padding: 24px;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #ddd #f5f5f5;
}

.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
}

/* 标题样式 */
.announcement-title {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.announcement-title h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.subtitle {
  color: #666;
  font-size: 16px;
}

/* 欢迎致辞 */
.welcome-message {
  line-height: 1.8;
  color: #555;
  margin-bottom: 32px;
  font-size: 15px;
}

.highlight {
  color: #6a11cb;
  font-weight: bold;
  padding: 0 4px;
  border-radius: 4px;
  background-color: rgba(106, 17, 203, 0.1);
}

/* 功能卡片容器 */
.features-container {
  display: grid;
  gap: 20px;
  margin-bottom: 32px;
}

/* 功能卡片样式 */
.feature-card {
  display: flex;
  gap: 16px;
  padding: 20px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-left: 4px solid #6a11cb;
  transform: translateY(20px);
  transition: all 0.5s ease;
}

/* 功能卡片动画 */
.feature-enter-0 {
  transition-delay: 0.1s;
  opacity: 1;
  transform: translateY(0);
}

.feature-enter-1 {
  transition-delay: 0.2s;
  opacity: 1;
  transform: translateY(0);
}

.feature-enter-2 {
  transition-delay: 0.3s;
  opacity: 1;
  transform: translateY(0);
}

.feature-enter-3 {
  transition-delay: 0.4s;
  opacity: 1;
  transform: translateY(0);
}

/* 功能图标 */
.feature-icon {
  font-size: 32px;
  min-width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-top: 4px;
  color: #6a11cb;
}

/* 功能内容 */
.feature-content {
  flex-grow: 1;
}

.feature-title {
  font-size: 18px;
  margin-bottom: 8px;
  color: #333;
}

.feature-description {
  color: #666;
  line-height: 1.7;
  margin-bottom: 8px;
  font-size: 14px;
}

.feature-benefit {
  color: #6a11cb;
  font-weight: 500;
  font-size: 14px;
  padding: 6px 12px;
  background-color: rgba(106, 17, 203, 0.08);
  border-radius: 4px;
  display: inline-block;
}

/* 不同卡片的颜色区分 */
.feature-card:nth-child(2) {
  border-left-color: #2575fc;
}

.feature-card:nth-child(2) .feature-icon {
  color: #2575fc;
}

.feature-card:nth-child(2) .feature-benefit {
  color: #2575fc;
  background-color: rgba(37, 117, 252, 0.08);
}

.feature-card:nth-child(3) {
  border-left-color: #ff7e5f;
}

.feature-card:nth-child(3) .feature-icon {
  color: #ff7e5f;
}

.feature-card:nth-child(3) .feature-benefit {
  color: #ff7e5f;
  background-color: rgba(255, 126, 95, 0.08);
}

.feature-card:nth-child(4) {
  border-left-color: #2ebf91;
}

.feature-card:nth-child(4) .feature-icon {
  color: #2ebf91;
}

.feature-card:nth-child(4) .feature-benefit {
  color: #2ebf91;
  background-color: rgba(46, 191, 145, 0.08);
}

/* 结尾部分 */
.closing-message {
  line-height: 1.8;
  color: #555;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 16px;
}

.gratitude {
  color: #6a11cb;
  font-weight: bold;
  margin: 16px 0;
}

.signature {
  display: flex;
  justify-content: flex-end;
  color: #888;
  margin-top: 20px;
  font-style: italic;
}

/* 底部按钮 */
.dialog-footers {
  width: 100%;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 16px 24px;
  background-color: #f9f9f9;
  border-top: 1px solid #f0f0f0;
}

.primary-btn {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  border: none;
  padding: 10px 32px;
  font-size: 16px;
  border-radius: 30px;
  transition: all 0.3s ease;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(106, 17, 203, 0.3);
  background: linear-gradient(135deg, #7b27c9 0%, #3a84fc 100%);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .update-dialog {
    width: 90% !important;
  }

  .feature-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .announcement-title h2 {
    font-size: 20px;
  }
}
</style>